import { render, staticRenderFns } from "./SlotTabs.vue?vue&type=template&id=35dfca62&scoped=true"
import script from "./SlotTabs.vue?vue&type=script&lang=ts"
export * from "./SlotTabs.vue?vue&type=script&lang=ts"
import style0 from "./SlotTabs.vue?vue&type=style&index=0&id=35dfca62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dfca62",
  null
  
)

export default component.exports